import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import { Button } from '@/components/ui/button';
import { ShoppingCart, User, LogOut, Leaf } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

export default function Navbar() {
  const { user, logout, cartCount } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <nav className="sticky top-0 z-50 border-b border-orange-800" style={{ background: 'rgba(204, 85, 0, 0.95)', backdropFilter: 'blur(12px)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          <Link to="/" className="flex items-center space-x-3" data-testid="nav-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_jfrai-tea-blends/artifacts/l9kcv1tj_JFRAI%20Family%20Rooted%20logo.png" 
              alt="JFRAI Family Rooted" 
              className="h-16 w-auto"
            />
            <span className="text-xl font-semibold text-white" style={{ fontFamily: 'Playfair Display, serif' }}>
              JFRAI Family Flavorful Brews & Tings
            </span>
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            <Link to="/who-we-are" className="text-white hover:text-cream-200 font-medium" data-testid="nav-who-we-are">
              Who We Are
            </Link>
            <Link to="/history" className="text-white hover:text-cream-200 font-medium" data-testid="nav-history">
              History
            </Link>
            <Link to="/shop" className="text-white hover:text-cream-200 font-medium" data-testid="nav-shop">
              Shop
            </Link>
            <Link to="/blend" className="text-white hover:text-cream-200 font-medium" data-testid="nav-blend">
              Custom Blend
            </Link>
            <Link to="/products" className="text-white hover:text-cream-200 font-medium" data-testid="nav-products">
              Tings
            </Link>
            <Link to="/subscriptions" className="text-white hover:text-cream-200 font-medium" data-testid="nav-subscriptions">
              Subscription Boxes
            </Link>
          </div>

          <div className="flex items-center space-x-4">
            <Link to="/cart" className="relative" data-testid="nav-cart">
              <Button variant="ghost" size="icon" className="relative">
                <ShoppingCart className="w-5 h-5" />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-terracotta-500 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center" data-testid="cart-count">
                    {cartCount}
                  </span>
                )}
              </Button>
            </Link>

            {user ? (
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="ghost" size="icon" data-testid="user-menu-trigger">
                    <User className="w-5 h-5" />
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end" className="w-48">
                  <div className="px-2 py-1.5">
                    <p className="text-sm font-medium">{user.name}</p>
                    <p className="text-xs text-muted-foreground">{user.email}</p>
                  </div>
                  <DropdownMenuSeparator />
                  <DropdownMenuItem onClick={() => navigate('/my-account')} data-testid="nav-my-account">
                    My Account
                  </DropdownMenuItem>
                  <DropdownMenuItem onClick={handleLogout} data-testid="nav-logout">
                    <LogOut className="w-4 h-4 mr-2" />
                    Logout
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            ) : (
              <Button onClick={() => navigate('/auth')} className="bg-sage-600 hover:bg-sage-700" data-testid="nav-login">
                Login
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
